import 'es6-shim';
import 'babel-polyfill';
import 'intersection-observer';
import Vue from 'vue';
import router from './router/index';
import './plugins/moment';
import i18n from './plugins/i18n';
import store from './store/index';
import vuetify from './plugins/vuetify';
import './plugins/gtm';
import setup from './helpers/interceptors';
import './plugins/vuelidate';

import App from './App.vue';
import './assets/styles/styles.scss';
// const App = () => System.import('./App.vue'); -- async loading

Vue.config.productionTip = false;

setup();

new Vue({
	vuetify,
	...App,
	router,
	store,
	i18n,
}).$mount('#app');
